import React, { useEffect, useState } from "react";
import { Select,Form } from 'antd';
import { isValid, isValidArray } from "../../../utils/utilities";
import { getStaffDetails } from "./staff-select.module";

const { Option } = Select;

const renderStaff=(data,staffType)=>{
    let staffArray=[];
    if(isValidArray(data)&&data.length>0){
        data.forEach(element => {
            if(isValidArray(element)&&isValid(element.name)){
                if(staffType == "all" || (staffType && element.staff_type === staffType)){
                    staffArray.push(<Option value={element.name} staff={element} key={element.id}>{element.name}</Option>)
                }
            }else{
                staffArray.push(<Option value={element} staff={element} key={element.id}>{element}</Option>)

            }
        });
    }
    return staffArray;
}

export const StaffSelect = ({
    data=[],
    showLabel=true,
    isManditory=true,
    selectStaff=null,
    isFormItem=true,
    onChange=(value)=>{},
    staffType="all",
    showLabelName="Driver Name",
    formName="driverName"
}) => {

    const [staff,setStaff] = useState(data);

    useEffect(()=>{
        if(isValidArray(data)&&data.length>0){
            setStaff(data);
        }else{
            getStaffDetails((info)=>{
                setStaff(info);
            },()=>{})
        }
    },[]);

if(isFormItem){
        return (
            <Form.Item
            name={formName}
            label={showLabel?showLabelName:''}
            rules={[{ required: isManditory, message: 'Please select staff type!' }]}
            >
                <Select
                    size="large"
                    showSearch
                    allowClear
                    placeholder="Select a staff type"
                    optionFilterProp="childrens"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    bordered={true}
                    defaultValue={selectStaff}
                    style={{minWidth:'200px'}}
                    onChange={onChange}
                >
                    {renderStaff(staff,staffType)}
                </Select>
            </Form.Item>
        )
    }else{
        return (
                 <Select
                    size="large"
                    showSearch
                    allowClear
                    placeholder="Select a staff type"
                    optionFilterProp="childrens"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    bordered={true}
                    defaultValue={selectStaff}
                    onChange={onChange}
                    style={{minWidth:'200px'}}
                >
                    {renderStaff(staff,staffType)}
                </Select>
        )
    }
}